import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileDetailsJobsConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFileDetailsJobStack = createStackNavigator();

const NCFileDetailsJobNavigator = () => {
  return (
    <NCFileDetailsJobStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileDetailsJobsConfig.map(({ Component, name }) => (
        <NCFileDetailsJobStack.Screen key={name} name={name} component={Component} />
      ))}
    </NCFileDetailsJobStack.Navigator>
  );
};

export { NCFileDetailsJobNavigator };
